export const SET_SHARED_VOUCHER_CODE = 'SET_SHARED_VOUCHER_CODE'

export const SET_PLANS_REQUESTING = 'SET_PLANS_REQUESTING'
export const SET_PLANS = 'SET_PLANS'
